import { render, staticRenderFns } from "./TheImageModal.vue?vue&type=template&id=5320f9d6&scoped=true"
import script from "./TheImageModal.vue?vue&type=script&lang=js"
export * from "./TheImageModal.vue?vue&type=script&lang=js"
import style0 from "./TheImageModal.vue?vue&type=style&index=0&id=5320f9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5320f9d6",
  null
  
)

export default component.exports